import { buildUsageLimit } from 'common-js/reducers/activation/actions/actionUtils';
import { useMemo } from 'react';

interface UseUsageLimitProps {
  dataLimit?: number;
  usageLimit: { type?: string; unit?: string; amount?: number };
}

const useUsageLimit = ({ dataLimit, usageLimit }: UseUsageLimitProps) => {
  const { type, unit, amount } = usageLimit;
  const usageLimitMemoized = useMemo(() => ({ type, unit, amount }), [amount, type, unit]);

  return useMemo(
    () => buildUsageLimit(dataLimit, usageLimitMemoized),
    [dataLimit, usageLimitMemoized]
  );
};

export default useUsageLimit;
